// extracted by mini-css-extract-plugin
export default {"brandCampaignSection":"BrandCampaignSections_brandCampaignSection__olE3c","brandCampaignSectionBackground":"BrandCampaignSections_brandCampaignSectionBackground__N+uGl"};